import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid} from '@material-ui/core';
import {Stack, Snackbar, Alert} from '@mui/material';
import {Select, MenuItem, FormControl } from '@mui/material';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
// import InputAdornment from '@mui/material/InputAdornment';
// import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress'; 
// import Tooltip from '@mui/material/Tooltip';
// import Authorization from '../components/Authorization';
// import LeadDetails from '../leads/LeadDetails'; 
// import LeadSave from './LeadSave';
///import LeadSaveEdit from './LeadSaveEdit';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

	var vertical='top',horizontal='center';
  
  export default function Execute() {
	const navigate = useNavigate();
	const location = useLocation();
	Cookies.set('leadPageUrl', 'leads', { expires: new Date(new Date().getTime() + 3600000*24*5) });
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	// const childRefCaseDetails = React.useRef();
	// const childRefSaveNew = React.useRef();
	///const childRefSaveEdit = React.useRef();
	const childRefAuthorization = React.useRef();
	const [dataLoading, setDataLoading] = React.useState(true);
	// const [page, setPage] = React.useState(0);
	//const [rowCount, setRowCount] = React.useState(74);
	//const pageSize = 100;
	
	const [type, setType] = React.useState("Today");

	// const [filterType, setFilterType] = React.useState("open");
	const [filter, setFilter] = React.useState(false);
	// const [selectedRow, setSelectedRow] = React.useState(0);
	// const [caseObj, setCaseObj] = React.useState({});
	const [rows, setRows] = React.useState([]);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	// const handlePageChange = (newPage) => {
	//   setSelectedRow(0);
	//   setCaseObj(null);
	//   setPage(newPage);
	//   setFilter(!filter);
	// };

	const columns = [
		{ field: 'ownerAlias', headerName: 'Agent', width: 180 },			
		{ field: 'calls', headerName: 'Call', type: 'number', width: 130 },
		{ field: 'emails', headerName: 'Email', type: 'number', width: 130 },
		{ field: 'meetings', headerName: 'Meeting', type: 'number', width: 130 },
		{ field: 'pipelineValue', headerName: 'Pipeline', type: 'number', width: 140, hide: type==='LastMonth'?true:false },
		{ field: 'bestLeadsValue', headerName: 'Best Leads', type: 'number', width: 180, hide: type==='LastMonth'?true:false },
		{ field: 'committedLeadsValue', headerName: 'Committed Leads', type: 'number', width: 180, hide: type==='LastMonth'?true:false },
		{ field: 'wonLeadsValue', headerName: 'Won Leads', type: 'number', width: 180 },
		{ field: 'payments', headerName: 'Payment', type: 'number', width: 180 },
	  ];

	React.useEffect(() => {		
		if(userObj && userObj.registerId>0){			
			getApiData();
		}
	}, [userObj, filter, location]);

	async function getApiData(){ 
		  let apiUrl=API_URL+'/crm-report-activity-agent?type='+type;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.status===200 && response.data && response.data.responseTxt==="success"){  
					setRows(response.data.list);	
					///setPrivileges(response.data.privileges);
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
		  	})	
	}



	// function selectRow(obj){
	// 	if(obj && rows[obj.id-1]){			
	// 		setSelectedRow(rows[obj.id-1].id);
	// 		setCaseObj(rows[obj.id-1]);
	// 	}
	// }

	// const handleOnCellClick = (obj) => {
	// 	if(obj.field==='relatedTitle'){
	// 		setCaseObj(rows[obj.id-1]);
	// 		if(caseObj){
	// 			childRefCaseDetails.current.handleClickOpen();
	// 		}
	// 	}	
	// };

	function search(){
		setFilter(!filter);
	}

	// function onEnter(event){
	// 	if(event.key === 'Enter'){
	// 		search();
	// 	}
	// }

	// function handleFilterType(val) {
	// 	setFilterType(val);
	// 	search();
	// }
	function handleType(val) {
		setType(val);
		search();
	}
		

	function hideAlert(){
		setShowAlert(false);
	}

	// function updatedList(list){
	// 	setSelectedRow(0);
	// 	setCaseObj(null);
	// 	setChannelId(0);
	// 	setStatus("noselect");
	// 	setType("noselect");
	// 	setFilterType("noselect");
	// 	setKeyword("");
	// 	setRows(list);
	// }


	
	return (
		<div> 
				<MetaTags>
            		<title>Activities</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Activities" />
				{dataLoading?<LinearProgress />:null}				
				<Box className='mainBox'>
				    <Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} >

									<FormControl size='small' style={{width:150,marginRight:4,marginBottom:4,float:'left'}}  >
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={type}
											onChange={event => handleType(event.target.value)}
										>
											<MenuItem value={'Today'}>Today</MenuItem>
											<MenuItem value={'ThisMonth'}>This Month</MenuItem>
											<MenuItem value={'LastMonth'}>Last Month</MenuItem>
											
										</Select> 
									</FormControl>


								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '78vh', width: '100%' }}>
					<DataGrid
							rows={rows}
							columns={columns}
							pageSize={100}
							rowHeight={40}
							rowsPerPageOptions={[100]}
							disableSelectionOnClick
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No record found!</span>
								  </Stack>
								)}}	
							///onRowClick={itm => selectRow(itm)}	
						/>
					</div>

				</Box>
				

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

			
		</div>	
	);
  }